var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.09 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #a01a57;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.51,2.73c-.36-.75-1.13-1.23-1.97-1.23s-1.6,.48-1.97,1.23l-4.4,9.04-9.82,1.45c-.82,.12-1.5,.7-1.76,1.48s-.05,1.65,.54,2.24l7.12,7.05-1.68,9.96c-.14,.82,.21,1.65,.88,2.14s1.57,.55,2.31,.16l8.77-4.68,8.77,4.68c.74,.39,1.63,.33,2.31-.16s1.02-1.32,.88-2.14l-1.69-9.96,7.12-7.05c.59-.58,.8-1.45,.54-2.24s-.94-1.36-1.76-1.48l-9.82-1.45L21.51,2.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.d88ee9a541b6253677487b98a37f9f09.svg";
export { ForwardRef as ReactComponent };